export default __webpack_public_path__ + "resources/icons/n140-79b9.webp";